import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import styles from './PaymentComponent.module.css';
import { FaLock } from 'react-icons/fa';

const DEFAULT_RETURN_URL = "https://www.usync.gg/paymentform/test/receipt";

export const NestedPaymentComponent = ({ price, returnUrl = DEFAULT_RETURN_URL }) => {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [agree, setAgree] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements || !agree) {
            return;
        }

        setLoading(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: returnUrl,
            },
        });

        // confirmPayment redirects to return_url on success, so `error` is only
        // populated when it resolves without redirecting (i.e. something failed).
        if (error) {
            if (error.type === "card_error" || error.type === "validation_error") {
                setMessage(error.message);
            } else {
                setMessage("An unexpected error occured.");
            }
        }

        setLoading(false);
    }

    const paymentOptions = {
        layout: "accordion"
    }

    return (
        <div className={`standardContainer ${styles.paymentContainer}`}>
            <form id={styles.paymentElement} className={styles.paymentForm} onSubmit={handleSubmit}>
                <p className={styles.paymentCardEyebrow}>Payment Details</p>

                <PaymentElement id={styles.paymentElement} options={paymentOptions} />

                <label className={styles.paymentLabel}>
                    <input type='checkbox' checked={agree} onChange={(e) => setAgree(e.target.checked)} />{" "}
                    I acknowledge that (i) payments for tickets, registrations, and donations related to events
                    listed on uSync.gg will be directed to the Event Organizer, (ii) uSync.gg will charge a platform fee of 5%
                    on the total payment made to the Event Organizer; and (iii) uSync.gg is not responsible for the deliverability
                    or quality of the Event.
                </label>

                <button disabled={loading || !stripe || !elements || !agree} id='submit' className={styles.paymentButton}>
                    <span className={styles.paymentButtonContent}>
                        {loading ? <div className={styles.spinner} /> : <><FaLock /> Pay ${price / 100} now</>}
                    </span>
                </button>

                {message && <div className={styles.paymentMessage}>{message}</div>}
            </form>
        </div>
    );
}
